import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Vehicle colors stats DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleColorsStatsDto extends BaseStatsDto {
	exterior!: number;
	interior!: number;
	accessory!: number;
	rim!: number;
}
